initMarquee('.Index_object_logo_marquee', {
    mobile: {
        duration: 30000,
        gap: 0,
        duplicated: true,
        direction: "left"
    },
    desktop: {
        duration: 30000,
        gap: 0,
        duplicated: true,
        direction: "left"
    }
});